/* eslint-disable @typescript-eslint/no-explicit-any */
import { SystemPermissionType } from './usePermissionToView'
import { useTypedSelector } from '../../stateStore'
import { reduxServices } from '../../reducers/reduxServices'
import { MappedTabs } from '../../types/MyProfile/ProfileLandingPage/myProfileTabsTypes'

export type UserAccessType = {
  hasPermission: boolean
  accessibility: (featureName: string) => SystemPermissionType
  accessibilityById: (userFeatId: number) => SystemPermissionType
  mapped: (featureNames: any[]) => MappedTabs[]
}

export default function usePermissionAccess(): UserAccessType {
  const userAccessToFeaturesByUser = useTypedSelector(
    reduxServices.userRolesConfigurations.selectors.userPermissionsToFeatures,
  )
  const userHasLoadedPermissions = useTypedSelector(
    reduxServices.userRolesConfigurations.selectors.userHasLoadedPermissions,
  )

  const getPermissions = (featureName: string): SystemPermissionType => {
    const user = userAccessToFeaturesByUser?.find(
      (feature) => feature.name === featureName,
    )
    return {
      featureId: Number(user?.featureId),
      name: user?.name ?? '',
      viewaccess: Boolean(user?.viewaccess),
      createaccess: Boolean(user?.createaccess),
      updateaccess: Boolean(user?.updateaccess),
      deleteaccess: Boolean(user?.deleteaccess),

      type: 'User-Role',
    }
  }

  const getPermissionsById = (userFeatId: number): SystemPermissionType => {
    const user = userAccessToFeaturesByUser?.find(
      (feature) => feature.featureId === userFeatId,
    )
    return {
      featureId: Number(user?.featureId),
      name: user?.name ?? '',
      viewaccess: Boolean(user?.viewaccess),
      createaccess: Boolean(user?.createaccess),
      updateaccess: Boolean(user?.updateaccess),
      deleteaccess: Boolean(user?.deleteaccess),

      type: 'User-Role-By-Feat-Id',
    }
  }

  const arrayPermissions = (featureNames: any[]): MappedTabs[] => {
    const mappedTabs: MappedTabs[] = [] as MappedTabs[]
    featureNames?.forEach((item) => {
      const user = userAccessToFeaturesByUser?.find(
        (feature) => feature.name === item.label,
      )
      const currentFeature = {
        featureId: Number(user?.featureId),
        name: user?.name || '',
        viewaccess: Boolean(user?.viewaccess),
        createaccess: Boolean(user?.createaccess),
        updateaccess: Boolean(user?.updateaccess),
        deleteaccess: Boolean(user?.deleteaccess),
        type: 'User-Role',
      }
      const hasViewAccess = Boolean(user?.viewaccess)
      if (hasViewAccess) {
        mappedTabs.push({
          ...item,
          ...currentFeature,
        })
      } else {
        mappedTabs.push({
          ...item,
          viewaccess: false,
          createaccess: false,
          updateaccess: false,
          deleteaccess: false,
        })
      }
    })
    return mappedTabs
  }

  return {
    hasPermission: userHasLoadedPermissions,
    accessibility: getPermissions,
    accessibilityById: getPermissionsById,
    mapped: arrayPermissions,
  }
}
